import { StyleSheet, Text, View } from 'react-native';
import React, { FC, useCallback } from 'react';
import { BookingType } from '../types';
import { useSelector } from 'react-redux';
import { RootState } from '../../../services/redux/store';
import { STYLE_VARS } from '../../../constants/style-vars';
import dayjs from 'dayjs';
import { Button } from '../../../components/Button';
import { FONTS } from '../../../constants';
import { IBookedSport } from '../../../types/sports.types';
import { convertToAmPm } from '../../../services/utils';

interface BookingSportProps {
  booking: IBookedSport;
  onCancelBooking?: (bookingId: string) => void;
  isPast?: boolean;
}

const BookingSport: FC<BookingSportProps> = ({
  booking,
  onCancelBooking,
  isPast = false,
}) => {
  const { user } = useSelector((redux: RootState) => ({
    user: redux.user.data,
  }));

  return (
    <View style={styles.wrapper}>
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        }}
      >
        <Text style={styles.name}>{booking.bk_bsdesc || ''}</Text>
        <Text
          style={[
            styles.textStyle,
            {
              width: '35%',
              textAlign: 'right',
            },
          ]}
        >
          {convertToAmPm(booking.bk_time)} - {convertToAmPm(booking.bk_totime)}
        </Text>
      </View>
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
        }}
      >
        <View style={{ width: '65%' }}>
          <Text style={styles.textStyle} numberOfLines={3}>
            {dayjs(booking.book_date || '').format('DD MMMM YYYY')}
          </Text>
          <Text style={styles.textStyle}>Type: Sport</Text>
          <Text style={styles.textStyle}>Court No: {booking.bk_emdesc}</Text>
          <Text style={styles.textStyle}>
            Status:{' '}
            {booking.bk_stat == 'B'
              ? 'Booked'
              : booking.bk_stat == 'X'
              ? 'Cancelled'
              : 'Complete'}
          </Text>
        </View>
        <View>
          {booking.bk_stat === 'B' && !isPast && (
            <Button
              text="CANCEL"
              style={STYLE_VARS.dangerButton}
              className=""
              onPress={() => {
                if (onCancelBooking) onCancelBooking(booking.bk_id);
              }}
            />
          )}
        </View>
      </View>
    </View>
  );
};

export default BookingSport;

const styles = StyleSheet.create({
  wrapper: {
    paddingVertical: 20,
    borderBottomColor: STYLE_VARS.fccDarkGrey,
    borderBottomWidth: 1,
  },
  name: {
    width: '65%',
    fontSize: 16,
    letterSpacing: 1,
    fontFamily: FONTS.IowanOldStyleBTRoman,
    color: STYLE_VARS.textColor,
    textTransform: 'uppercase',
  },
  textStyle: {
    fontSize: 13,
    lineHeight: 20,
    letterSpacing: 1,
    fontFamily: FONTS.IowanOldStyleBTRoman,
    color: STYLE_VARS.fccDarkerGrey,
    textTransform: 'uppercase',
  },
});
